import React, {Component, useContext, useEffect, useState} from 'react';

import {Link} from "react-router-dom";
import {FormControl, InputLabel, MenuItem, Select} from "@material-ui/core";
import Datatable from "../common-components/datatables/datatable";
import Axios from "axios";
import {catchApiErrors, expulsarIfTokenInvalido, getLocalStorageData} from "../../helpers/auth-helpers";
import {AuthDataContext} from "../../context/auth-context";
import DivGrisTitulo from "../common-components/seccion-titulo";
import RenderHeader from "../common-components/header";
import {BackdropCargandoContext} from "../../context/backdrop-cargando-context";
import { useTranslation } from 'react-i18next';
import {useAlert} from "react-alert";
import moment from "moment";
import {returnProvincia} from "../../helpers/generales";
import imges from "../../img/atca.png"
import imgca from "../../img/ates.png"
function ElTeuConsum(props) {

    const [FiltroCorbes, setFiltroCorbes] = useState();
    const {state} = useContext(AuthDataContext);
    const {backdrop_state,backdrop_dispatch} = useContext(BackdropCargandoContext);
    const alert = useAlert();

    const [dataDatatable, setdataDatatable] = useState();
    const { t, i18n } = useTranslation();


    function handleChange() {

    }

    const columns = [
        {
            name: "CUPS",
            label: "CUPS",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "DataInici",
            label: t('data_inici'),
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {

                    return (
                        <> {moment(value).format('DD-MM-YYYY')}</>
                    );
                }
            },

        },
        {
            name: "DataFinal",
            label: t('data_fi'),
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {

                    return (
                        <> { value!='' ? moment(value).format('DD-MM-YYYY') : ''}</>
                    );
                }
            },

        },
        {
            name: "TARIFA",
            label: t('te'),
            options: {
                filter: true,
                sort: false,
                display: false,



            }

        },
        {
            name: "POTENCIA",
            label: t('pc2'),
            options: {
                filter: true,
                sort: false,
                display: false,

                customBodyRender: (value, tableMeta, updateValue) => {

                    return (
                        <> {value.replace('.',',')} kWh</>
                    );
                }
            },

        },
        {
            name: "DOMICILI",
            label: t('direccion'),
            options: {
                filter: true,
                sort: false,

            }
        },
        {
            name: "poblacio",
            label: t('poblacion'),
            options: {
                filter: true,
                sort: false,

            }
        },
        {
            name: "codi_post",
            label: "C.Postal",
            options: {
                filter: true,
                sort: false,
                display: false,

            }
        },
        {
            name: "provincia",
            label: t('provincia'),

            options: {
                filter: true,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <> {returnProvincia(tableMeta.rowData[7])}</>
                    );
                }
            }
        },

        {
            name: "grafico",
            label: t('curvas'),
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {

                    return (
                        <Link to={{
                            pathname: '/grafico-consumo',
                            state: {"cups": tableMeta.rowData[0],  "tarifa": tableMeta.rowData[3],"potencia_contratada": tableMeta.rowData[4], "direccion": tableMeta.rowData[5] +', '+ tableMeta.rowData[7] +', '+ tableMeta.rowData[6] +' '+ returnProvincia(tableMeta.rowData[7])}
                        }} className="Btn-transparent-border-green Btn-small">

                            {t('consultarcorba')}

                        </Link>
                    );
                }
            },

        }
    ];

    const options = {
        selectableRows: 'none',
        responsive:'scrollMaxHeight',

    }
    useEffect(() => {
        backdrop_dispatch({
            type: 'open',
            data: {}
        });
        Axios.defaults.headers.common['Authorization'] = `Bearer ${JSON.parse(getLocalStorageData('token'))}`;
        Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
        Axios.defaults.withCredentials = true;
        Axios.post(`https://api.zona-privada.electracaldensedistribucio.com/api/mi_consumo/get_peatges`, {uuid: state.user.uniqid})
            .then(res => {

                setdataDatatable(res.data.data)
                backdrop_dispatch({
                    type: 'close',
                    data: {}
                });
            }).catch(function (error) {
            catchApiErrors(error,backdrop_dispatch,t,alert)
        })

    }, [])


    return (
        <>
            <RenderHeader/>

            <DivGrisTitulo tituloBienvenida={false} titulo={t('consum')}/>

            <div className="El-teu-consum Padding-seccion-principal">
                <div className=" px-3 container">

                    <div className="row">
                        <div className="col-12 col-md-8 d-flex flex-wrap">

                            <h2 className=" Titulo2 mb-4">
                                {t('ccc')}
                            </h2>
                            <p>{t('aq')}</p>

                            <div>
                                <h5 className=" Titulo3 mt-5 mb-4">
                                    {t('selecrao')}
                                </h5>
                            </div>
                            <div className="Row-flex Row_input_btn my-2">

                            <FormControl className="mt-0" fullWidth>
                                    <InputLabel>
                                        {t('razon_social')}
                                    </InputLabel>

                                    <Select required onChange={handleChange} name="filtro_corbes" fullWidth
                                            value={FiltroCorbes} defaultValue="nif1">

                                        <MenuItem value="nif1">
                                            {state.user.tipo == 'representante' ? state.user.razon_social : state.user.nombre + ' ' + state.user.apellidos}

                                        </MenuItem>


                                    </Select>


                                </FormControl>
                                <button className="Btn Btn_green Btn-movil" type="button"><span>Aplicar</span></button>

                            </div>

                        </div>
                        <div className="col-12 col-md-4 d-flex flex-column">
                            <div className="d-flex flex-column">


                              {/*  <hr/>*/}
                                <div className=" Caja-gris Inferior-Contador ">
                                    <a href="tel:+34900181776" className="mw-100 mh-100 d-block">
                                        {
                                            getLocalStorageData('lang') === 'es'
                                                ?
                                                <img src={imges} className="w-100 h-100" style={{'objectFit': 'cover'}}
                                                     alt=""/>
                                                :
                                                <img src={imgca} className="w-100 h-100" style={{'objectFit': 'cover'}}
                                                     alt=""/>
                                        }
                                    </a>

                                </div>
                         {/*       <hr/>*/}


                            </div>
                        </div>

                        <div className="col-12 mt-5">
                           {/* PARA QUE CARGUE EL SPINNER EN LA TABLA
                            {dataDatatable ? <Datatable titulo="Peatges" data={dataDatatable} options={options} columns={columns}/> :
                                <CircularProgress className="mx-auto" disableShrink/>}*/}
                            {!backdrop_state.open && <Datatable titulo={t('peatges')} data={dataDatatable} options={options} columns={columns}/> }
                        </div>
                    </div>
                </div>

            </div>

        </>
    );
}

export default ElTeuConsum;